import axios, { AxiosRequestConfig, Method, AxiosResponse, AxiosError } from 'axios';

export interface CustomHeaders {
  [headerParam: string]: string;
}

export const getUserToken = (): any => {
  const localUser = localStorage.getItem('user');
  let user;
  if (localUser) {
    user = JSON.parse(localUser);
  }

  return user
    ? {
        // WCToken: user.WCToken,
        // WCTrustedToken: user.WCTrustedToken,
      }
    : null;
};

class HttpClient {
  private headers: CustomHeaders = {
    Authorization: '',
  };

  private requestConfig: AxiosRequestConfig = {};

  executeRequest = (): Promise<AxiosResponse> => {
    const requestHandler = (request: any) => {
      // request.headers = { "Content-Type": "application/json" };
      // if (request.url?.includes("backOffice")) {
      //   request.headers = getUserToken();
      // }

      return request;
    };

    axios.interceptors.request.use(request => requestHandler(request));
    return new Promise((resolve, reject) => {
      axios(this.requestConfig)
        .then(response => resolve(this.responseHandler(response)))
        .catch(error => reject(this.errorHandler(error)));
    });
  };

  setRequestConfig = (
    url: string,
    method: Method,
    params?: URLSearchParams | string | null,
    headers?: CustomHeaders | null,
    withCredentials?: boolean,
    data?: any
  ): void => {
    this.requestConfig = {
      url,
      method,
      headers: headers ? headers : this.headers,
      withCredentials,
      // timeout: 10000,
    };

    if (params) {
      this.requestConfig.params = params;
    }

    if (data) {
      this.requestConfig.data = data;
    }
  };

  private responseHandler = (response: AxiosResponse) => {
    return response;
  };

  private errorHandler = (error: AxiosError) => {
    if (error.response?.status === 401 || error.response?.status === 504) {
      localStorage.clear();
      const url = `${process.env.PUBLIC_URL}/login`;
      window.location.href = url;
    }

    return error;
  };
}

export const createAndExecuteService = async ({
  url,
  method,
  queryParams = null,
  headers = {},
  withCredentials = false,
  data,
}: {
  url: string;
  method: Method;
  queryParams?: URLSearchParams | null;
  headers?: CustomHeaders | null | undefined;
  withCredentials?: boolean;
  data?: any;
}): Promise<AxiosResponse> => {
  const parsedUrl = url;
  const http = new HttpClient();

  http.setRequestConfig(parsedUrl, method, queryParams, headers, withCredentials, data);
  return await http.executeRequest();
};
